/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmitPscInconsistencyReportRequest as ModelsSubmitPscInconsistencyReportRequest } from '../../models/models/submit-psc-inconsistency-report-request';
import { SubmitPscInconsistencyReportResponse as ModelsSubmitPscInconsistencyReportResponse } from '../../models/models/submit-psc-inconsistency-report-response';

export interface ApiV1BorPscInconsistencyReportsPost$Params {
  
    /**
     * PSC inconsistency report
     */
    body: ModelsSubmitPscInconsistencyReportRequest
}

export function apiV1BorPscInconsistencyReportsPost(http: HttpClient, rootUrl: string, params: ApiV1BorPscInconsistencyReportsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSubmitPscInconsistencyReportResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1BorPscInconsistencyReportsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSubmitPscInconsistencyReportResponse>;
    })
  );
}

apiV1BorPscInconsistencyReportsPost.PATH = '/api/v1/bor/psc/inconsistency-reports';
